var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './ImageInput.module.css';
import classNames from 'classnames';
import 'react-image-crop/dist/ReactCrop.css';
import { getImageFrom, trimFileName } from './utils';
import CropEditor from './CropEditor';
import Dropdown from './Dropdown';
/**
 * Input для изображений, основан на React-Dropzone
 * https://react-dropzone.js.org
 * */
export default function ImageInput(_a) {
    var _b;
    var _c;
    var updateImage = _a.updateImage, image = _a.image, style = _a.style, title = _a.title, isValid = _a.isValid, validationMessage = _a.validationMessage, aspect = _a.aspect, imageTypes = _a.imageTypes, additionalActions = _a.additionalActions, label = _a.label, required = _a.required, onBlur = _a.onBlur;
    var _d = __read(useState(false), 2), dropdownVisible = _d[0], setDropdownVisible = _d[1];
    var _e = __read(useState(false), 2), cropEditorVisible = _e[0], setCropEditorVisible = _e[1];
    var isDialogWindowOpened = useRef(false);
    var onDropAccepted = useCallback(function (acceptedFiles) {
        getImageFrom(acceptedFiles[0]).then(updateImage);
    }, [updateImage]);
    var _f = useDropzone({
        onDropAccepted: onDropAccepted,
        accept: imageTypes && imageTypes.length
            ? imageTypes.map(function (type) { return "image/".concat(type); })
            : 'image/*',
        multiple: false,
        noClick: !!image,
        noDrag: !!image
    }), getRootProps = _f.getRootProps, getInputProps = _f.getInputProps, isDragActive = _f.isDragActive, isFileDialogActive = _f.isFileDialogActive, inputRef = _f.inputRef;
    var requiredForPlaceHolder = !label && required;
    var customTitle = title
        ? "".concat(title, " ").concat(requiredForPlaceHolder ? '*' : '')
        : undefined;
    var defaultTitle = "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 ".concat(requiredForPlaceHolder ? '*' : '');
    var text = image
        ? trimFileName(image.name)
        : isDragActive
            ? 'Перенесите изображение сюда'
            : customTitle !== null && customTitle !== void 0 ? customTitle : defaultTitle;
    var handleEdit = function () {
        setCropEditorVisible(true);
    };
    var handleReplace = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleDelete = function () {
        updateImage();
        setDropdownVisible(false);
    };
    var actions = (_c = additionalActions === null || additionalActions === void 0 ? void 0 : additionalActions.map(function (_a) {
        var name = _a.name, action = _a.action;
        return ({
            title: name,
            action: function () {
                setDropdownVisible(false);
                action();
            }
        });
    })) !== null && _c !== void 0 ? _c : [];
    useEffect(function () {
        if (isFileDialogActive && !isDialogWindowOpened.current) {
            isDialogWindowOpened.current = true;
        }
        if (!isFileDialogActive && isDialogWindowOpened.current && onBlur) {
            onBlur();
        }
    }, [isFileDialogActive]);
    return (React.createElement("section", { className: styles.container, style: style },
        React.createElement("div", __assign({}, getRootProps(), { className: classNames(styles.input, (_b = {},
                _b[styles.inputFilled] = image,
                _b[styles.inputInvalid] = isValid === false,
                _b)) }),
            React.createElement("input", __assign({}, getInputProps({
                // allow replacing cropped files
                // https://stackoverflow.com/a/40429197
                onClick: function (event) {
                    ;
                    event.target.value = '';
                }
            }))),
            text,
            image && (React.createElement("button", { type: 'button', className: styles.moreButton, onClick: function (event) {
                    event.stopPropagation();
                    setDropdownVisible(true);
                } })),
            image && cropEditorVisible && (React.createElement(CropEditor, { image: image, updateImage: updateImage, aspect: aspect, close: function () { return setCropEditorVisible(false); } })),
            React.createElement(Dropdown, { dropdownVisible: dropdownVisible, hideDropdown: function () { return setDropdownVisible(false); }, handleEdit: handleEdit, handleReplace: handleReplace, handleDelete: handleDelete, additionalActions: actions })),
        isValid === false && (React.createElement("div", { className: styles.validationMessage }, validationMessage))));
}
